/**
 * Removes numeric characters from a string. Used for first/last name fields
 * so users cannot enter numbers (requirement: names must not allow digits).
 * @param {string} value - Raw input value
 * @returns {string} - Value with digits removed
 */
export const stripNumbersFromName = (value) => {
  if (value == null || typeof value !== "string") return value ?? "";
  return value.replace(/\d/g, "");
};
